import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';

import * as serviceWorker from './serviceWorker';

import * as Sentry from '@sentry/react';

const container = document.getElementById('root');
const root = createRoot(container, {
  // handle uncaught errors (including those not caught by error boundaries)
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo);
  }),
  // callback when React automatically recovers from an error, e.g. after an error boundary handles an error
  onRecoverableError: Sentry.reactErrorHandler()
});

if (root !== null) {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
